import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SessionService } from "@app/shared/services/session.service";
import { CompanyService } from '@src/app/shared/backend/clients';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from '@src/app/shared/components/toaster/toaster.service';
import { Currency } from '@src/app/shared/enums/Currency.enum';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-company-form',
    templateUrl: './company-form.component.html',
    styleUrls: ['./company-form.component.scss'],
    host: {
        class: 'app-company-form'
    },
    standalone: false
})
export class CompanyFormComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() disableIsPrepaired = false;

  imageUpdated = false;
  hasAssistanceSerialNumberImage: boolean = false;
  assistanceSerialNumberImagePath: string | null = null;
  assistanceSerialNumberImage: SafeUrl | null = null;
  imageLoadFailed = false;

  file: File | null = null;
  fileUploadError: string = '';

  currencies = Object.values(Currency).map(value => ({ label: value, value }));

  constructor(
    public session: SessionService,
    public translate: TranslateService,
    public toasterService: ToasterService,
    private companyService: CompanyService,
    private sanitizer: DomSanitizer) { }

  async ngOnInit(): Promise<void> {
    this.session.currentCompanyData$.subscribe(async company => {
      const path = company?.assistanceImagePath ?? null;
      const hasImg = !!path;

      this.hasAssistanceSerialNumberImage = hasImg;
      this.assistanceSerialNumberImagePath = path;

      if (hasImg) {
        try {
          const resp = await firstValueFrom(this.companyService.apiCompanyAssistanceImageGet());
          const base64 = resp?.response ?? null;
          this.assistanceSerialNumberImage = base64 ? this.sanitizer.bypassSecurityTrustUrl(base64) : null;
        } catch (error) {
          console.error('Error fetching assistance image:', error);
        }
      } else {
        this.assistanceSerialNumberImage = null;
      }
    });
  }

  get identifierControl() {
    return this.formGroup.get('identifier');
  }

  convertIdentifierToLowercase(): void {
    const identifier = this.identifierControl?.value;
    const lowercaseIdentifier = identifier.toLowerCase();

    if (identifier !== lowercaseIdentifier) {
      this.identifierControl?.setValue(lowercaseIdentifier);
    }
  }

  trimIdentifier(): void {
    const identifier = this.identifierControl?.value;
    const trimmedIdentifier = identifier.trim();

    if (identifier !== trimmedIdentifier) {
      this.identifierControl?.setValue(trimmedIdentifier);
    }
  }
}
